"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.generateInitialProductsStatus = generateInitialProductsStatus;
exports.generateStatusForAllProducts = generateStatusForAllProducts;
exports.PRODUCT_STATUS = void 0;
var PRODUCT_STATUS = {
  LOADING: 'loading',
  NO_STATUS: 'no_status',
  CURRENT_PRODUCT: 'current_product',
  CAN_ACTIVATE: 'can_activate',
  ACCESS_NEEDED: 'access_needed',
  CAN_SWITCH: 'can_switch'
};
exports.PRODUCT_STATUS = PRODUCT_STATUS;

function generateInitialProductsStatus(currentProduct) {
  var initialProductsStatus = generateStatusForAllProducts(PRODUCT_STATUS.LOADING);
  initialProductsStatus[currentProduct] = PRODUCT_STATUS.CURRENT_PRODUCT;
  return initialProductsStatus;
}

function generateStatusForAllProducts(status) {
  return {
    appoptics: status,
    pingdom: status,
    papertrail: status,
    loggly: status
  };
}